// extracted by mini-css-extract-plugin
module.exports = {"events_container":"UpcomingEvents_events_container__UGSLJ","events_list":"UpcomingEvents_events_list__pPqRq"};